import { useRoute } from 'vue-router';
import { computed } from 'vue';

const useAuthenticatedQuery = () => {
  const route = useRoute();
  const queriesEnabled = computed(() => {
    return (
      !!route.params.userIndex &&
      !Number.isNaN(Number(route.params.userIndex)) &&
      document.cookie.includes(`token_expiry_u_${route.params.userIndex}`)
    );
  });
  const userIndex = computed(() => route.params.userIndex?.toString() ?? null);

  return { queriesEnabled, userIndex };
};
export default useAuthenticatedQuery;
